// extracted by mini-css-extract-plugin
export default {"file":"File_file__zcHWb","delete":"File_delete__JZ8Kq","icon":"File_icon__Pfrqu","preview":"File_preview__5BMvp","name":"File_name__2MFtd"};